import {Box, Tooltip, Typography} from "@mui/material";
import {c, mono, softShadow} from "../landingTokens";
import {Section} from "./Shell";
import axiansLogo from "../../../assets/images/axians.webp";
import finkiLogo from "../../../assets/images/finki.png";
import fitrLogo from "../../../assets/images/fitr.png";
import zanMitrevLogo from "../../../assets/images/zan-mitrev.png";

const PARTNERS = [
    {name: "FINKI", image: finkiLogo, href: "https://finki.ukim.mk/", maxHeight: 84, maxWidth: 118},
    {name: "Axians", image: axiansLogo, href: "https://www.axians.mk/", maxHeight: 50, maxWidth: 210},
    {name: "FITR", image: fitrLogo, href: "https://fitr.wearetribeca.io/", maxHeight: 68, maxWidth: 136},
    {
        name: "Zan Mitrev Clinic",
        image: zanMitrevLogo,
        href: "https://zmc.mk/",
        maxHeight: 88,
        maxWidth: 116,
        offsetY: 8
    },
];

export const Partners = () => (
    <Section id="backed" label="Partners" sx={{textAlign: "center"}}>
        <Typography sx={{
            fontFamily: mono,
            fontSize: "11.5px",
            letterSpacing: "0.16em",
            textTransform: "uppercase",
            color: c.purpleDeep,
            mb: 4.25
        }}>
            Built and backed with
        </Typography>

        {/* Logos gathered into one soft trust panel, divided by hairlines. */}
        <Box
            className="reveal-stagger"
            sx={{
                bgcolor: c.white,
                borderRadius: "28px",
                boxShadow: softShadow,
                display: "grid",
                gridTemplateColumns: {xs: "1fr 1fr", md: "repeat(4, minmax(0, 1fr))"},
                px: {xs: 2, md: 3},
                py: {xs: 2, md: 1.5},
            }}
        >
            {PARTNERS.map((partner, i) => (
                <Tooltip key={partner.name} title={partner.name} arrow>
                    <Box
                        component={partner.href ? "a" : "div"}
                        href={partner.href}
                        target={partner.href ? "_blank" : undefined}
                        rel={partner.href ? "noopener noreferrer" : undefined}
                        sx={{
                            height: {xs: 96, md: 112},
                            textDecoration: "none",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            px: 2,
                            // Violet hairline between logos; skip the first cell of each row.
                            borderLeft: {
                                xs: i % 2 === 0 ? "none" : `1px solid rgba(124,108,246,0.14)`,
                                md: i % 4 === 0 ? "none" : `1px solid rgba(124,108,246,0.14)`,
                            },
                        }}
                    >
                        <Box
                            component="img"
                            src={partner.image}
                            alt={partner.name}
                            sx={{
                                maxWidth: partner.maxWidth || "100%",
                                maxHeight: partner.maxHeight || 68,
                                objectFit: "contain",
                                filter: "grayscale(1) contrast(0.9)",
                                opacity: 0.62,
                                transform: partner.offsetY ? `translateY(${partner.offsetY}px)` : "none",
                                transition: "filter .25s ease, opacity .25s ease",
                                "&:hover": {
                                    filter: "grayscale(0) contrast(1)",
                                    opacity: 1,
                                },
                            }}
                        />
                    </Box>
                </Tooltip>
            ))}
        </Box>
    </Section>
);
